<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { useClass } from "~/composables/local/cn-class"

const props = defineProps<{
	class?: HTMLAttributes["class"]
}>()

const className = useClass(
	"w-fit rounded-sm bg-website-primary px-10px py-1 text-sm text-primary-foreground",
	() => props.class,
)
</script>

<template>
	<span :class="className">
		<slot />
	</span>
</template>
